import { Link as RouterLink } from "react-router-dom"
import {
  Chip,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material"
import type { LicenceDownloadRow } from "@xop/dashboard-shared"

/**
 * The download journal, as a table — shared by the per-licence panel in the
 * builder and the cross-licence page. Every row is one PULL of a licence file,
 * refusals included: the refusals are the half anyone needs after an incident.
 */

function when(iso: string): string {
  return iso.replace("T", " ").slice(0, 16)
}

export function DownloadJournalTable({
  rows,
  showLicence = false,
  emptyText = "No downloads yet.",
}: {
  rows: LicenceDownloadRow[]
  /** The cross-licence page names WHICH licence each row belongs to. */
  showLicence?: boolean
  emptyText?: string
}) {
  if (rows.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {emptyText}
      </Typography>
    )
  }

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>When</TableCell>
            {showLicence ? <TableCell>Customer</TableCell> : null}
            {showLicence ? <TableCell>Appliance</TableCell> : null}
            <TableCell>File</TableCell>
            <TableCell>Who</TableCell>
            <TableCell>From</TableCell>
            <TableCell>Result</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow key={row.id} hover>
              <TableCell sx={{ whiteSpace: "nowrap" }}>{when(row.downloadedAt)}</TableCell>
              {showLicence ? (
                <TableCell>
                  <Link component={RouterLink} to={`/crm/licences/${row.licenceId}`}>
                    {row.customerName}
                  </Link>
                </TableCell>
              ) : null}
              {showLicence ? <TableCell>{row.label || row.hardwareAddress}</TableCell> : null}
              <TableCell sx={{ fontFamily: "monospace", fontSize: 12 }}>{row.serial}</TableCell>
              <TableCell>
                {row.actorLabel}
                <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
                  {row.actorType}
                </Typography>
              </TableCell>
              <TableCell sx={{ fontFamily: "monospace", fontSize: 12 }} title={row.userAgent ?? ""}>
                {row.ip ?? "—"}
              </TableCell>
              <TableCell>
                {row.refused ? (
                  <Chip size="small" color="error" label="Refused" />
                ) : (
                  <Chip size="small" color="success" variant="outlined" label="Downloaded" />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}
